import { genComponentStyleHook } from './styleUtil'
import { genStyle } from './checkboxStyle'

export default genComponentStyleHook(['Radio', 'techTheme'], (token) => {
  return [genStyle(token as any)]
})
